var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-view-list-field',{attrs:{"align":"center","is-sticky":_vm.isSticky,"field":_vm.field,"filter":_vm.filter}},[_c('core-divisive',{attrs:{"score":_vm.item.users.divisiveness,"count":_vm.item.users.totalRatings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }